module.exports = __webpack_public_path__ + "img/close-error.7be950f4.svg";